/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const key = ['pageSpecificData'];

type PageSpecificData = {
  productRecommendationType: string;
  productRecommendationInteraction: string;
  productFindingMethod: string;
  pfmLocation: string;
  searchOriginalPartTypeId: string;
  searchProductRepositoryId: string;
  searchResultPosition: string;
  ignoreNextPageViewCall: boolean;
  eventType: string;
  navigationInteraction: string;
  navigationLink: string;
  internalCampaignInteraction: string;
};

const initialData: PageSpecificData = {
  productRecommendationType: '',
  productRecommendationInteraction: '',
  productFindingMethod: '',
  pfmLocation: '',
  searchOriginalPartTypeId: '',
  searchProductRepositoryId: '',
  searchResultPosition: '',
  ignoreNextPageViewCall: false,
  eventType: '',
  navigationInteraction: '',
  navigationLink: '',
  internalCampaignInteraction: '',
};

const setPageSpecificData = (data: Partial<PageSpecificData>) => {
  return Promise.resolve(data);
};

export const usePageSpecificData = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: key,
    queryFn: () => {
      throw new Error("This query shouldn't be refetched");
    },
    initialData,
    staleTime: Infinity,
  });
  const mutation = useMutation({
    mutationKey: key,
    mutationFn: setPageSpecificData,
    onSuccess: (newData) => {
      queryClient.setQueryData(key, { ...data, ...newData });
    },
  });

  return {
    pageSpecificData: data,
    setPageSpecificData: mutation.mutate,
  };
};
